/* eslint-disable default-case */
import { useState } from 'react';
import { upload, remove } from 'services/firebase/storage';
import { AppError } from 'models';
import { MediaType } from 'models/forms';

interface MessagesHookResponse {
  fileUrl: string | null;
  loading: boolean;
  error: null | AppError;
  upload: (
    file: Blob | File,
    mediaType: MediaType,
    fileName?: string,
  ) => Promise<string | null>;
  uploadWithLoading: (
    file: Blob | File,
    mediaType: MediaType,
    fileName?: string,
  ) => Promise<void>;
  remove: (path: string) => Promise<boolean>;
}

const useStorage = (): MessagesHookResponse => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null as null | AppError);
  const [fileUrl, setFileUrl] = useState(null as null | string);

  const uploadFile = async (
    file: Blob | File,
    mediaType: MediaType,
    fileName?: string,
  ): Promise<string | null> => {
    const result = await upload(file, mediaType, fileName);
    return result.type !== 'error' ? result.data : null;
  };

  const uploadFileWithLoading = async (
    file: Blob | File,
    mediaType: MediaType,
    fileName?: string,
  ): Promise<void> => {
    setLoading(true);
    const result = await upload(file, mediaType, fileName);
    switch (result.type) {
      case 'success':
        setFileUrl(result.data);
        break;
      case 'error':
        setError(result.error);
        break;
    }
    setLoading(false);
  };

  const removeFile = async (path: string): Promise<boolean> => {
    const result = await remove(path);
    return result.type !== 'error';
  };

  return {
    fileUrl,
    loading,
    error,
    upload: uploadFile,
    uploadWithLoading: uploadFileWithLoading,
    remove: removeFile,
  };
};

export default useStorage;
